import React from 'react';
import _get from 'lodash/get';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import InsuranceOptions from 'components/v2/insurance/insurance-options';
import styles from './delivery-guarantee.less';

const SingleDeliveryGuarantee = ({
  onChange,
  deliveries,
  deliveriesInsuranceDetails,
}) => {
  const {
    selectedInsuranceOptionID,
    selectedInsuranceOption,
    optionsCount,
  } = deliveriesInsuranceDetails;
  const options = _get(deliveries, '[0].quote.insurance.options');
  return (
    <div className={styles.content}>
      <p className={styles.message}>
        {selectedInsuranceOption ? (
          <span>{selectedInsuranceOption.subtitle}</span>
        ) : (
          <span>{I18n.t('v2.anytimeBooking.insurance.subtitle')}</span>
        )}
        {deliveries.length > 1 &&
          selectedInsuranceOption && (
            <span>
              {' '}
              {I18n.t('v2.anytimeBooking.insurance.appliedToAllItems')}
            </span>
          )}
      </p>
      <InsuranceOptions
        selectedInsuranceOptionID={selectedInsuranceOptionID}
        onChange={onChange}
        options={options}
        optionsCount={optionsCount}
      />
    </div>
  );
};

SingleDeliveryGuarantee.propTypes = {
  onChange: PropTypes.func.isRequired,
  deliveries: PropTypes.arrayOf(NewBookingDeliveryPropType).isRequired,
  deliveriesInsuranceDetails: PropTypes.shape({}).isRequired,
};

export default SingleDeliveryGuarantee;
